import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { default as MaterialDialog } from '@material-ui/core/Dialog';
import { DialogTitle, Typography, Button as MaterialButton, LinearProgress, DialogActions } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import Button from './Button';
import SnackbarContent from './SnackbarContent';

var styles = function styles(theme) {
  return {
    dialog: {
      minWidth: '352px',
      minHeight: '144px'
    },
    title: {
      paddingTop: '10px',
      paddingLeft: '24px',
      paddingRight: '24px',
      paddingBottom: '8px'
    },
    modalButton: {
      padding: '7px',
      position: 'absolute',
      width: '28px',
      minWidth: '28px',
      height: '28px',
      minHeight: '28px',
      top: '0px',
      right: '0px'
    },
    progressBar: {
      position: 'absolute',
      top: '0px',
      width: '100%'
    },
    actions: {
      marginRight: '20px',
      marginBottom: '8px'
    },
    message: {
      paddingLeft: '24px',
      paddingRight: '24px',
      paddingTop: '14px',
      paddingBottom: '10px'
    }
  };
};

var Dialog =
/*#__PURE__*/
function (_Component) {
  _inherits(Dialog, _Component);

  function Dialog() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Dialog);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Dialog)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.onClose = function () {
      var onClose = _this.props.onClose;
      if (onClose) onClose();
    }, _this.onSuccess = function () {
      var onSuccess = _this.props.onSuccess;
      if (onSuccess) onSuccess();
    }, _temp));
  }

  _createClass(Dialog, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          title = _props.title,
          modal = _props.modal,
          loading = _props.loading,
          showCancel = _props.showCancel,
          children = _props.children,
          classes = _props.classes,
          closeText = _props.closeText,
          error = _props.error,
          message = _props.message,
          moreActions = _props.moreActions,
          other = _objectWithoutProperties(_props, ['title', 'modal', 'loading', 'showCancel', 'children', 'classes', 'closeText', 'error', 'message', 'moreActions']);

      return React.createElement(MaterialDialog, other, React.createElement('div', {
        className: classes.dialog
      }, title !== undefined && React.createElement(DialogTitle, {
        disableTypography: true,
        className: classes.title
      }, React.createElement(Typography, {
        variant: 'h5'
      }, title)), modal && React.createElement(MaterialButton, {
        onClick: this.onClose,
        className: classes.modalButton
      }, React.createElement(CloseIcon, {
        className: classes.modalButtonIcon
      })), loading && React.createElement(LinearProgress, {
        className: classes.progressBar
      }), error && React.createElement(SnackbarContent, {
        squared: true,
        variant: 'error',
        message: error
      }), message ? React.createElement(Typography, {
        className: classes.message
      }, message) : children), (showCancel || moreActions) && React.createElement(DialogActions, {
        className: classes.actions
      }, showCancel && React.createElement(Button, {
        color: 'secondary',
        variant: 'text',
        onClick: this.onClose
      }, closeText || 'Cancel'), moreActions && moreActions.map(function (action) {
        return React.createElement(Button, {
          color: action.color,
          variant: action.variant,
          onClick: action.onClick
        }, action.label);
      })));
    }
  }]);

  return Dialog;
}(Component);

Dialog.propTypes = _extends({}, MaterialDialog.propTypes, {
  title: PropTypes.string,
  modal: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.string,
  message: PropTypes.string,
  showCancel: PropTypes.bool,
  closeText: PropTypes.string,
  successText: PropTypes.string
});
export default withStyles(styles)(Dialog);